(function() {
  'use strict';

  angular.module('cfn').factory('cfnCredentialsCompany', cfnCompany);

  function cfnCompany() {
    var company = app.credentials.company;
    var service = {
      getCountryExtend: getCountryExtend,
      getCountryCenter: getCountryCenter
    };

    return angular.extend({}, company, service);

    function getCountryExtend() {
      var geojson_format,
        countryOutline = company.countryOutlineGeometry,
        olGeometry;

      // Get boundaries of country outline
      geojson_format = new ol.format.GeoJSON();
      olGeometry = geojson_format.readGeometry(JSON.parse(countryOutline));

      // Convert to projection of map
      return ol.proj.transformExtent(
        olGeometry.getExtent(),
        'EPSG:4326',
        'EPSG:3857'
      );
    }

    function getCountryCenter() {
      return ol.extent.getCenter(getCountryExtend());
    }
  }
})();
